@let authenticated = authenticated$ | async;

<footer class="footer-container">
    <mat-toolbar class="footer-toolbar" [class.footer-toolbar--mobile]="isMobile$ | async">
        <img [src]="logo" alt="Medpace Logo" class="logo" />

        <div class="footer-links">
            <span>© {{ currentYear }} Medpace, All Rights Reserved</span>
            <mds-divider [vertical]="true" [style]="'height: 100%;'" />

            <a href="https://www.medpace.com/privacy-policy/" target="_blank" rel="noreferrer noopener">
                Privacy Policy
            </a>
            <mds-divider [vertical]="true" [style]="'height: 100%;'" />

            <a href="https://www.medpace.com/accessibility-statement/" target="_blank" rel="noreferrer noopener">
                Accessibility Statement
            </a>
            <mds-divider [vertical]="true" [style]="'height: 100%;'" />

            <a href="https://www.medpace.com/terms-of-use/" target="_blank" rel="noreferrer noopener">Terms of Use</a>
            <mds-divider [vertical]="true" [style]="'height: 100%;'" />

            @if (authenticated) {
                <a [routerLink]="['/global-contact-numbers']">Global Contact Numbers</a>
                <mds-divider [vertical]="true" [style]="'height: 100%;'" />
            }

            <span>US Toll Free: <a href="tel:+1866-715-4403">+1 866-715-4403</a> </span>
            <mds-divider [vertical]="true" [style]="'height: 100%;'" />

            <span>
                Email: <a href="mailto:{{ emailAddress }}">{{ emailAddress }}</a>
            </span>
            <mds-divider [vertical]="true" [style]="'height: 100%;'" />

            <span [attr.hashVersion]="this.hashVersion">{{ appName }} version {{ appVersion }}</span>
            <mds-divider [vertical]="true" [style]="'height: 100%;'" />

            <span>Session will time out in: {{ timer$ | async }}</span>
        </div>

        @if (authenticated) {
            <mds-button
                [variant]="'tonal'"
                [color]="'primary'"
                [label]="'Report a bug'"
                (clickEvent)="sendErrorsDetails()"
            />
        }
    </mat-toolbar>
</footer>
